import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { CSpinner, useColorModes } from '@coreui/react'
import './scss/style.scss'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { THEME_STORAGE_KEY } from './themePreference'


// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))



const App = () => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(null);
  const { isColorModeSet, setColorMode } = useColorModes(THEME_STORAGE_KEY)
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("accessToken");
      setIsAuthenticated(!!token);
    };

    checkAuth();
    window.addEventListener("authChanged", checkAuth);


    const urlParams = new URLSearchParams(window.location.search);
    const themeFromUrl = urlParams.get('theme');
    if (themeFromUrl) {
      setColorMode(themeFromUrl);
    } else if (!isColorModeSet()) {
      const saved = localStorage.getItem(THEME_STORAGE_KEY);
      setColorMode(saved || "light");
    }

    const handleAppThemeChanged = (event) => setColorMode(event.detail)
    window.addEventListener('appThemeChanged', handleAppThemeChanged)

    return () => {
      window.removeEventListener("authChanged", checkAuth);
      window.removeEventListener('appThemeChanged', handleAppThemeChanged)
    };
  }, [isColorModeSet, setColorMode])

  if (isAuthenticated === null) {
    return (
      <div className="pt-3 text-center">
        <CSpinner color="primary" variant="grow" />
      </div>
      
    );
  }
  return (
    <BrowserRouter >
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="/*" element={isAuthenticated ? (<DefaultLayout />) : (<Navigate to="/login" replace />)} />
        </Routes>
      </Suspense>
      <ToastContainer position="top-right" autoClose={3000} theme="colored"  newestOnTop closeOnClick pauseOnHover draggable/>
    </BrowserRouter > 
    
  )
}

export default App
